module.exports = "/build/admin/images/apple-touch-icon-180x180.4be20219.png";